<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="mt-2">
      BUSCAR CLIENTES
      <template v-slot:actions>
        <v-btn class="mr-5" @click.native.stop="reload()" icon small>
            <v-icon color="primary">mdi-reload</v-icon>
        </v-btn>
        <v-btn @click="$store.dispatch('deleteWindowByUuid', { uuid: win.uuid })" icon small>
            <v-icon color="error">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-card>
        <v-tabs v-model="tab" dark background-color="primary" icons-and-text>
          <v-tabs-slider color="red"></v-tabs-slider>
          <v-tab href="#tab-1">Lista de Clientes<v-icon>mdi-account-search</v-icon></v-tab>
          <v-tab href="#tab-2" v-if="$store.getters['rolesUser/getCustomRole'](18)">Edición Masiva<v-icon>mdi-pencil-box-multiple</v-icon></v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" touchless>
          <v-tab-item value="tab-1">
      <v-card flat class="pa-1" rounded="lg">
        <v-card-text class="pa-0">
          <GeneralFilter class="background border-box" 
            :filterEndpoint="$API.customers.filterCustomers"
            :columnsFilterEndpoint="$API.customers.getCustomersByColumns"
            :search="{ ...search, filteredFrom: 0 }"
            :columns.sync="columnsFilter" 
            @emptyFilter="getAllCustomers"
            @filtered="filterHandler"
            @loading="loading = $event"
            advanced-filter
            showAllRecordsToggle
            :showAllRecords="showAllRecords"
            @onShowAllRecordsChange="onShowAllRecordsChange"
          >
            <DxDataGrid class="isScrolledByGeneralFilter" :data-source="customers" key-expr="ID_Customer"
              :show-row-lines="showRowLines" @exporting="onExporting" :show-borders="showBorders"
              :row-alternation-enabled="rowAlternationEnabled" :column-auto-width="true">
              <DxExport :enabled="true" />
  
              <DxScrolling row-rendering-mode="virtual" />
              <DxPaging :page-size="15" />
              <DxColumn :width="80" cell-template="show-template" v-if="$store.getters['rolesUser/getCustomRole'](78)"
               caption=""></DxColumn>
              <DxColumn data-field="ID_Customer" caption="ID"></DxColumn>
             <!--  <DxColumn cell-template="name-template" caption="Nombre del Cliente" ></DxColumn> -->
              <!-- <DxColumn data-field="customerNameToShow" caption="Nombre "></DxColumn> -->
              <DxColumn cell-template="show-template-name" caption="Nombre"></DxColumn>

              <!-- <DxColumn data-field="customerEmailToShow" caption="Correo "></DxColumn>  -->
              <DxColumn cell-template="show-template-email" caption="Correo"></DxColumn>
              <DxColumn data-field="LegalName" caption="Nombre Legal"></DxColumn> 
              <DxColumn data-field="AdditionalInformation" :caption="additionalInformationTitle"></DxColumn>
              <!-- <DxColumn data-field="Email" caption="Correo "></DxColumn> -->
           <!--    <DxColumn cell-template="email-template" caption="Correo"></DxColumn> -->
  
              <!-- <DxColumn data-field="BusinessName" caption="Nombre de Negocio"></DxColumn> -->
              <!-- <DxColumn data-field="BusinessEmail" caption="Correo de Negocio"></DxColumn> -->
  
              <DxColumn data-field="Is_a_Business" falseText="No" trueText="Si" :showEditorAlways="false"
                caption="Es negocio"></DxColumn>
  
              <DxColumn data-field="OldID" caption="Código alterno"></DxColumn> 
              <DxColumn caption="Clase" cell-template="show-template-class"></DxColumn>
              <DxColumn caption="Categoría" cell-template="show-template-category"></DxColumn>
              <DxColumn caption="Subcategoría" cell-template="show-template-subcategory"></DxColumn>

              <template #show-template-name="{ data }">
                <div>{{ `${data.data.Is_a_Business || data.data.Is_a_Ong  || data.data.Is_a_PublicEntity ? data.data.BusinessName : `${data.data.FirstName} ${data.data.LastName}` }` }}</div>
              </template>
              <template #show-template-email="{ data }">
                <div>{{ `${data.data.Is_a_Business || data.data.Is_a_Ong  || data.data.Is_a_PublicEntity ? data.data.BusinessEmail : `${data.data.Email}` }` }}</div>
              </template>
              <template #show-template-class="{ data }">
                <div>{{ showClass(data.data.id_class) }}</div>
              </template>
              <template #show-template-category="{ data }">
                <div>{{ showCategories(data.data.id_category) }}</div>
              </template>
              <template #show-template-subcategory="{ data }">
                <div>{{ showSubs(data.data.id_subcategory) }}</div>
              </template>
              <template #show-template="{ data }">
                <a class="mx-1" @click="customerSelected(data)">
                  <v-icon color="primary">mdi-eye</v-icon>
                </a>
              </template>
              <template #name-template="{ data }">
                <p v-if="data.data.Is_a_Business || data.data.Is_a_Ong  || data.data.Is_a_PublicEntity">
                  {{ data.data.BusinessName }}
                </p>
                <p v-else>
                  {{ data.data.FirstName }} {{ data.data.LastName }}
                </p>
              </template>
              <template #email-template="{ data }">
                <p v-if="data.data.Is_a_Business || data.data.Is_a_Ong  || data.data.Is_a_PublicEntity">
                  {{ data.data.BusinessEmail }}
                </p>
                <p v-else>
                  {{ data.data.Email }}
                </p>
              </template>
  
            </DxDataGrid>
          </GeneralFilter>
          <!-- <div class="background border-box">
            <div>
            </div>
          </div> -->
        </v-card-text>
      </v-card>
      <block v-model="loading"></block>
          </v-tab-item>
          <v-tab-item value="tab-2" v-if="$store.getters['rolesUser/getCustomRole'](18)">
            <CustomersBulkEdit ref="bulkEdit" @saved="getAllCustomers" />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { DxDataGrid, DxColumn, DxScrolling, DxPaging,DxExport } from 'devextreme-vue/data-grid';
// import CustomerData from "./tabs/CustomerData";
import { mapGetters } from 'vuex';
import { printToExcel } from "@/helpers/printToexcel";
import GeneralFilter from  "@/components/GeneralFilter";
import _ from 'lodash';
import CustomersBulkEdit from './tabs/CustomersBulkEdit.vue';

export default {
  name: "CustomersList",
  components: { DxDataGrid, DxColumn, DxScrolling, DxPaging, DxExport, GeneralFilter, CustomersBulkEdit },
  props: ['win'],
  data() {
    const additionalInformationTitle = Number(JSON.parse(localStorage.getItem("user") || "{}").IsOptical) === 1
      ? "Lugar de trabajo"
      : "Información adicional";
    return {
      tab: 'tab-1',
      additionalInformationTitle,
      showCustomer: false,
      customers: [],
      showRowLines: true,
      showBorders: true,
      showAllRecords: false,
      rowAlternationEnabled: true,
      search: {},
      reloadwindow: 0,
      filter: null,
      loading: false,
      categoriesAll: [],
      subcategoriesAll: [],
      columnsFilterDefault: [],
      columnsFilter: [
        {
          name: "ID_Customer",
          title: "Id de Cliente",
          value: "",
        }, 
        {
          name: "FirstName",
          title: "Nombre",
          value: "",
        },
        {
          name: "LastName",
          title: "Apellido",
          value: "",
        },
        {
          name: "id_class",
          title: "Clase",
          value: "",
          type: "select",
          options: [],
          onChange: this.getCategoriesByClass,
        },
        {
          name: "id_category",
          title: "Categoría",
          value: "",
          type: "select",
          options: [],
          onChange: this.getSubsByCategory,
          disabled: true,
        },
        {
          name: "id_subcategory",
          title: "Subategoría",
          value: "",
          type: "select",
          options: [],
          disabled: true,
        },
        {
          name: "AdditionalInformation",
          title: additionalInformationTitle,
          value: "",
        },
      ],
    }
  },
  mounted() {
    this.search.business = JSON.parse(localStorage.getItem("user")).businessid || "";
    this.search.branch = JSON.parse(localStorage.getItem("user")).branch || "";
    this.columnsFilterDefault = _.cloneDeep(this.columnsFilter);
    this.getAllCustomers();
    this.getClasses();
    this.getCategories();
    this.getSubs();
  },
  computed: {
    ...mapGetters(['reloadData'])
  },
  watch: {
    reloadData: {
      immediate: true,
      handler: 'reloadCustomers'
    }
  },
  methods: {
    onShowAllRecordsChange(value) {
      this.showAllRecords = value;
    },
    onExporting(e) {
      printToExcel(e, 'Clientes');
    },
    reload(){
      if (this.tab === 'tab-2' && this.$refs.bulkEdit) {
        this.$refs.bulkEdit.searchCustomers();
        return;
      }
      this.getAllCustomers();
      this.columnsFilter = _.cloneDeep(this.columnsFilterDefault);
      this.getClasses();
      this.getCategories();
      this.getSubs();
      setTimeout(() => {
        window.scrollTo(0, this.$store.getters.getScrollTop)
        //alert(this.$store.getters.getScrollTop)
      },300);
    },
    getAllCustomers() {
      this.loading = true
      // console.log('this.search', this.search);
      // console.log('this.showAllRecords', this.showAllRecords);
      this.$API.customers.getCustomersHistory({...this.search, showAllRecords: this.showAllRecords})
        .then(response => {
         // response = this.prepareCustomersResponse(response);
          this.customers = response;
         /*  console.log('customers all', response); */
        })
        .finally(() => {
          this.loading = false
        })
    },
    getClasses() {
      this.$API.customersTypes.getClasses().then((response) => {
        this.columnsFilter[3].options = response.map(element => ({name: element.name, value: element.id}));
      });
    },
    getCategories() {
      this.$API.customersTypes.getCategories().then((response) => {
        this.columnsFilter[4].options = response.map(element => ({name: element.name, value: element.id}));
        this.categoriesAll = response;
      });
    },
    getSubs() {
      this.$API.customersTypes.getSubs().then((response) => {
        this.columnsFilter[5].options = response.map(element => ({name: element.name, value: element.id}));
        this.subcategoriesAll = response;
      });
    },
    getCategoriesByClass() {
      delete this.columnsFilter[4].value;
      delete this.columnsFilter[5].value;
      this.columnsFilter[4].options = this.categoriesAll.filter(element => element.id_class === this.columnsFilter[3].value).map(element => ({name: element.name, value: element.id}));
      this.columnsFilter[4].disabled = false;
      this.columnsFilter[5].disabled = true;
    },
    getSubsByCategory() {
      delete this.columnsFilter[5].value;
      this.columnsFilter[5].options = this.subcategoriesAll.filter(element => element.id_cat === this.columnsFilter[4].value).map(element => ({name: element.name, value: element.id}));
      this.columnsFilter[5].disabled = false;
    },
    showClass(idClass) {
      const classData = this.columnsFilter[3].options.find(element => element.value === idClass);
      return classData?.name ?? '';
    },
    showCategories(idCategory) {
      const categoryData = this.categoriesAll.find(element => element.id === idCategory);
      return categoryData?.name ?? '';
    },
    showSubs(idSubcategory) {
      const subcategoryData = this.subcategoriesAll.find(element => element.id === idSubcategory);
      return subcategoryData?.name ?? '';
    },
    prepareCustomersResponse(response) {
      return response.map(customer => {
        console.log('preparing ', customer);
        if (customer.Is_a_Business) {
          customer.customerNameToShow = customer.BusinessName;
          customer.customerEmailToShow = customer.BusinessEmail;
        }
        else{
          customer.customerNameToShow = customer.FirstName + ' ' + customer.LastName;
          customer.customerEmailToShow = customer.Email;
        }
        
        return customer;
      })
    },
    filterHandler(response) {
      // console.log('filter handler', response);
      this.customers = response;
    },
    async reloadCustomers() {
      if (this.reloadData == 'customers') {
        await this.getAllCustomers();
        this.$store.dispatch('reloadData', null)
      }
    },
    showCustomerHandler(data) {
      this.panel = null;
      this.showCustomer = data;
      if (this.$route.query['cust_id']) {
        let query = Object.assign({}, this.$route.query);
        delete query.cust_id;
        this.$router.replace({ query });
      }
    },
    customerSelected(data) {
      let send = this.customers.filter(customer => customer.ID_Customer == data.data.ID_Customer)
      this.$store.commit('customerData/changeView', 'tab-1'); 
      this.$store.dispatch('addWindow', {
        'name': 'customerData',
        component: 'CustomerData',
        unique: false,
        meta: { customerToShow: send[0] }
      })
    }
  }
}
</script>

<style scoped>
.border-box {
  border-radius: 15px !important;
}
.background {
    background: white !important;
    color: white;
}
</style>
